import type { RouteObject } from 'react-router';
import { PageAccueil } from './PageAccueil.tsx';
export const routesAccueil: RouteObject[] = [{ index: true, element: <PageAccueil /> }];
